import { privateApi } from 'services/Api/ApiService';
import { TalentStatus, SaveTalentStatus } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchTalentStatuses = (businessAccountId: string): Promise<TalentStatus[]> =>
    privateApi.get<TalentStatus[]>(`business-accounts/${businessAccountId}/leads/talent-statuses`);

const updateTalentStatus = (id: string, payload: SaveTalentStatus): Promise<TalentStatus> =>
    privateApi.put(`talent-statuses/${id}`, payload);

const createTalentStatus = (businessAccountId: string, payload: SaveTalentStatus): Promise<TalentStatus> =>
    privateApi.post(`business-accounts/${businessAccountId}/leads/talent-statuses`, payload);

const archiveTalentStatus = (id: string): Promise<void> => privateApi.post(`talent-statuses/${id}/archive`);

const unarchiveTalentStatus = (id: string): Promise<void> => privateApi.post(`talent-statuses/${id}/unarchive`);

export const TalentStatusesGateway = {
    fetchTalentStatuses,
    updateTalentStatus,
    createTalentStatus,
    archiveTalentStatus,
    unarchiveTalentStatus,
};

const cancelableFetchTalentStatuses = (businessAccountId: string): Promise<TalentStatus[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentStatus[]>(
        `business-accounts/${businessAccountId}/leads/talent-statuses`,
    );

export const CancelableTalentStatusesGateway = {
    cancelableFetchTalentStatuses,
};
